import maEventbus from '@/components/eventbus/index.js'

import maInputSelect from '@/components/input/modules/select'

import { mapState, mapActions } from 'vuex'

import { WARRANTY_MODULE_NAME, WARRANTY_UPDATE_AREA } from '@/store/types'

/**
 *
 */
export default {
  name: 'InputTextArea',

  /**
   * @property {String} icon VueSVGicon
   * @property {String} placeholder Placeholder to show while input is empty.
   * @property {String} type Text input could also be of type number, password.
   * @property {Boolean} removeIcon If true, shows X to delete input content.
   */

  data() {
    return {
      height: null,
      width: null,
      selected: 'm',
      units: [
        { key: 'm', literal: 'm' },
        { key: 'cm', literal: 'cm' }
      ]
    }
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    valueTextNumber: {
      type: String,
      require: true
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    maInputSelect
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyHeight: 'heightArea',
      stateWarrantyWidth: 'widthArea',
      stateWarrantyUnit: 'unitArea'
    })
  },
  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actStateWarrantyArea: WARRANTY_UPDATE_AREA
    }),
    handleMeasure(event) {
      if (event.target.name === 'height') {
        this.height = event.target.value
      } else if (event.target.name === 'width') {
        this.width = event.target.value
      } else {
        console.error('El valor introducido no es numérico')
      }
    },

    emitMeasure(value) {
      this.selected = value
      if (this.height != null && this.width != null && this.selected === 'm') {
        let area = this.height * this.width
        this.actStateWarrantyArea({
          height: this.height,
          width: this.width,
          selected: this.selected
        })
        maEventbus.$emit('update:area', area)
      } else if (
        this.height != null &&
        this.width != null &&
        this.selected === 'cm'
      ) {
        let heightCentimeters = this.height / 100
        let widthCentimeters = this.width / 100
        let area = heightCentimeters * widthCentimeters
        this.actStateWarrantyArea({
          height: this.height,
          width: this.width,
          selected: this.selected
        })
        maEventbus.$emit('update:area', area)
      } else {
        console.error('No entra en el bucle')
      }
    },
    resetInputValue() {
      this.actStateWarrantyArea({
        height: '',
        width: '',
        selected: 'm'
      })
    }
  },
  mounted() {
    this.height = this.stateWarrantyHeight
    this.width = this.stateWarrantyWidth
    this.selected = this.stateWarrantyUnit
    this.$parent.$on('reset-event', this.resetInputValue())
  },
  beforeDestroy() {
    this.$parent.$off('reset-event', this.resetInputValue)
  }
}
